import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ClassName from 'classnames'

export default class MetaVoice extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isPlaying: false,
        }
    }

    play() {
        if (this.player !== undefined) {
            if (this.state.isPlaying) {
                this.player.pause()
                this.player.currentTime = 0
                this.setState({
                    isPlaying: false
                })
            } else {
                this.player.play()
                this.setState({
                    isPlaying: true
                })
            }
        }
    }

    stop() {
        this.setState({
            isPlaying: false
        })
    }

    _click() {
        // if (this.props.sound === undefined || this.props.sound.length === 0) {
        //     this.props.showInputMeta(this.props.index, this.props.type);
        // }  
    }

    renderAudio() {
        if (this.props.sound !== undefined && this.props.sound.length > 0) {
            return (
                <audio ref={(c) => this.player = c} src={this.props.sound} onEnded={(e) => this.stop(e)} />
            )
        }
    }

    renderController() {
        if (this.props.sound !== undefined && this.props.sound.length > 0) {
            return (
                <img className="VoiceController" src={this.state.isPlaying ? require("../image/stop.png") : require("../image/play.png")} role="presentation" />
            )
        }
    }

    isEmpty() {
        if (this.props.sound !== undefined || this.props.sound.length <= 0) {
            return true
        }
        return false
    }

    render() {
        return (
            <div className={ClassName('meta', this.isEmpty() ? 'AddMeta' : '')} style={this.props.position} onClick={(e) => this.play()}>
                <div className="match_parent">
                    { this.renderAudio() }
                    <img className="match_parent VoiceImage" src={this.props.image} role="presentation" onClick={(e) => this._click()}/>
                    { this.renderController() }
                </div>
            </div>
        )
    }
}

MetaVoice.propTypes = {
    position: PropTypes.object.isRequired,
    sound: PropTypes.string,
    image: PropTypes.string,
    index: PropTypes.number,
    type: PropTypes.string,
    showInputMeta: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/components/MetaVoice.js